import React, {useState} from 'react'
import {TemplateNameRibbon} from "@exceed.ai/exceed-utils"
import {Icon} from "react-onsenui";
import JoditEditor from "jodit-react";
import BackButton from "components/BackButton";
import EditResponseTemplate from './EditResponseTemplate'
import EmptyToolbar from "components/EmptyToolbar";

// eslint-disable-next-line import/no-anonymous-default-export
export default ({
                    navigator,
                    content,
                    senderPlatform,
                    setContent,
                    editorRef,
                    templateToApprove,
                    userItem,
                    selectDifferentTemplate,
                    approveClicked
                }) => {
    const config = {
        disabled: templateToApprove.templateType === "Default Email",
        readonly: false,
        spellcheck: false,
        enter: "DIV",
        minHeight: '50px',
        height: '100%',
        enableDragAndDropFileToEditor: false,
        toolbarAdaptive: false,
        toolbarButtonSize: "small",
        toolbarInlineForSelection: true,
        toolbarInline: false,
        showXPathInStatusbar: false,
        askBeforePasteHTML: false,
        askBeforePasteFromWord: false,
        colorPickerDefaultTab: 'color',
        buttons: ['font',
            {
                name: 'fontsize',
                icon: 'fontSizeIcon',
            },
            '|',
            'bold',
            'strikethrough',
            'italic',]
    }
    const [copyContent, setCopyContent] = useState(content);

    const handleBlur = (value, e) => {
        // only when losing focus to a target that is not jodit related or another jodit editor - like in contact later
        if (value && (!e?.relatedTarget?.parentElement?.getAttribute("class")?.startsWith("jodit") || e?.relatedTarget?.parentElement?.getAttribute("class") === "jodit-workplace")) {
            setContent(value);
            setCopyContent(value);
        }
    }

    const editResponseTemplate = async () => {
        await navigator.replacePage({
            title: "task.id",
            backButton: <BackButton navigator={navigator} text={"Cancel"}/>,
            Component: () => <EditResponseTemplate templateToApprove={templateToApprove} userItem={userItem}
                                                   selectDifferentTemplate={selectDifferentTemplate}
                                                   senderPlatform={senderPlatform}
                                                   navigator={navigator}/>
        });
    }

    return <div className="flex-col flex-1" style={{overflowY: "auto"}}>
        <EmptyToolbar right={<div className="text-primary"
                                  onClick={() => approveClicked(templateToApprove, copyContent)}>Done</div>}
                      left={<BackButton navigator={navigator} text={"Cancel"}/>}/>

        <div id={"task_sequence_details"} className="exceed_page">
            <p className="task_header">Response</p>
            <div className="flex-space-between">
                <TemplateNameRibbon templateName={templateToApprove.templateType}/>
                <Icon
                    onClick={editResponseTemplate}
                    style={{paddingRight: "10px"}}
                    size={{default: 26}}
                    icon={{default: 'edit'}}
                />
            </div>
        </div>
        <hr/>
        <JoditEditor
            ref={editorRef}
            value={content}
            config={config}
            tabIndex={1}
            onBlur={handleBlur}
        />
    </div>
}